import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
// import { theme } from '../../../themes/theme';

const WarningButton = styled(({ ...props }: any) => (
    <Button variant="contained" {...props} />
))(({ theme, label }) => ({
    minWidth: 0,
    minHeight: 0,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    background: `${theme.palette.error[600]}`,
    border: `1px solid ${theme.palette.error[600]}`,
    color: 'white',
    height: '40px',
    ':hover': {
        background: theme.custom.primaryBtnColor,
        border: '1px solid black',
        color: 'black',
    },
    '&.Mui-disabled': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
    },
}));

export default WarningButton;
